<template lang="html">
    <div class="sidebar-left-menu prepended" style="background-color:#f27046">
        <div class="h2 present">Прогнозы</div>
        <ul class="sidebar-left-menu-main">
            <li v-for="(item, index) in items" :key="index" :class="`sidebar-left-menu-main-item ${path == item.link ? '-active' : ''} ${item.items ? '-items' : ''}`">
                <router-link v-if="!item.items" :to="item.link" :title="item.text">{{ item.text }}</router-link>
                <a v-else @click="item.open = !item.open" :class="`item-name ${item.open ? 'active' : ''}`">{{ item.text }}</a>
                <ul v-if="item.items" class="sidebar-left-menu-main-submenu">
                    <li v-for="(subitem, index) in item.items" :key="index" :class="`sidebar-left-menu-main-item ${path == subitem.link ? '-active' : ''}`">
                        <router-link :to="subitem.link" :title="subitem.text">{{ subitem.text }}</router-link>
                    </li>
                </ul>
            </li>
        </ul>
    </div>

</template>

<script>
export default {
    data(){
        return {
            path: null,
            items: [
                {
                    text: 'На сегодня',
                    link: '/forecasts/today'
                },
                {
                    text: 'На завтра',
                    link: '/forecasts/tomorrow'
                },
                {
                    open: true,
                    text: 'По видам спорта',
                    items: [
                        {
                            text: 'Все виды спорта',
                            link: '/forecasts/all'
                        },
                        {
                            text: 'Футбол',
                            link: '/forecasts/football'
                        },
                        {
                            text: 'Хоккей',
                            link: '/forecasts/hockey'
                        },
                        {
                            text: 'Теннис',
                            link: '/forecasts/tennis'
                        },
                        {
                            text: 'Баскетбол',
                            link: '/forecasts/basketball'
                        }
                    ]
                }
            ]
        }
    },
    mounted(){
        this.updateMenu()
        this.$bus.$on('updateRoute', this.updateMenu)
    },
    methods: {
        updateMenu(){
            this.path = this.$route.path
        }
    },
    beforeDestroy(){
        this.$bus.$off('updateRoute', this.updateMenu)
    }
}
</script>

<style lang="css">
</style>
